var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "youtube-feed-app" },
    [
      _c("youtube-feed", {
        attrs: {
          token: "AIzaSyAT45yvJJ055sX8rnDw70LL4cer1cDIJ8g",
          profile: "Thesouthernhighlands",
          playlist: _vm.playlist,
          count: 4,
          displayLoadMore: true,
          displayTitle: true,
          displayDescription: true
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib?{}!./scripts/vue/YoutubeTemplate.vue?vue&type=template&id=68840f39&
// module id = 119
// module chunks = 9